// @ts-nocheck
/* eslint-disable react/prop-types */
import React from 'react';
import { Row, Col, Table, Button, Typography, Form, Modal, Pagination } from 'antd';
import { GLOBAL_TABLE_PAGE_SIZE, prodMode } from 'global_config/constant-global';
import { RegexInput } from 'shared_components/pattern_input';
import PageTitle from 'shared_components/page_title';
import SearchPager from 'shared_components/search_pager';
import Message from 'shared_components/message';
import { searchDonors } from 'services/blood_bank/donor_registration';
import scanImage from 'images/bloodbank/donor_reg/fingerprint.gif';
import MatchFoundModal from './modal/matchFound';
import NoMatchFoundModal from './modal/noMatchFound';
import NoScannerFound from './modal/noScannerFound';
import DonorRegSteps from '../DonorRegSteps';

import './index.css';
// import { fetchLabResultExamItems } from "services/lab_result/result";

const { Text } = Typography;
const columns = [
	{
		title: "DONOR'S ID",
		dataIndex: 'donor_id',
		defaultSortOrder: 'descend',
		sorter: (a, b) => a.donor_id - b.donor_id,
		fixed: 'left',
		width: 100,
	},
	{
		title: 'LAST NAME',
		dataIndex: 'last_name',
		defaultSortOrder: 'descend',
		sorter: (a, b) => a.last_name - b.last_name,
		fixed: 'left',
		width: 150,
	},
	{
		title: 'FIRST NAME',
		dataIndex: 'first_name',
		defaultSortOrder: 'descend',
		sorter: (a, b) => a.first_name - b.first_name,
		width: 150,
	},
	{
		title: 'MIDDLE NAME',
		dataIndex: 'middle_name',
		width: 150,
	},
	{
		title: 'GENDER',
		dataIndex: 'gender',
		width: 80,
	},
	{
		title: 'BIRTHDATE',
		dataIndex: 'birth_date',
		width: 100,
	},
	{
		title: 'ADDRESS',
		render: record =>
			`${record.address_line_1} ${
				record.address_line_2 === null ? '' : record.address_line_2
			} ${','} ${record.barangay_name} ${','} ${record.city_name} ${','} ${record.province_name}`,
		width: 400,
	},
	{
		title: 'BLOOD TYPE',
		dataIndex: 'blood_type_name',
		// render: record => record.custom_fields_list.blood_type
		width: 100,
	},
	{
		title: 'LAST EXTRACTED',
		dataIndex: 'last_extracted_date',
		width: 120,
		fixed: 'right',
	},
];

class DonorRegSearch extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			pageSize: GLOBAL_TABLE_PAGE_SIZE,
			loading: false,
			data: [],
			donorID: 0,
			count: 0,
			page: 1,
			actionType: null,
			modalVisible: true,
			showModalNoMatchFound: false,
			isDisplayModal: false,
			modalVisibleNoMatchFound: false,
			modalNoTerminalFound: false,
			prodMode: prodMode,
		};
		this.formRef = React.createRef();
	}

	handleChangeSize = async pageSize => {
		const { donorName, page, donorID } = this.state;
		const donors = await searchDonors(donorName, donorID, pageSize, page);
		this.setState({
			pageSize,
			response: donors,
			count: donors.count,
			data: donors.results,
		});
	};

	handleSubmit = async data => {
		const { pageSize, page } = this.state;
		const { donorName, donorId } = data;

		this.setState({ loading: true });

		const donors = await searchDonors(donorName, donorId, pageSize, page);
		console.log('🚀 ~ file: index.js ~ line 107 ~ DonorRegSearch ~ handleSubmit= ~ donors', donors);

		this.setState({
			loading: false,
			data: donors.results,
			count: donors.count,
			donorName,
			donorId,
			showPagination: donors ? donors.results.length > 0 : 0,
			actionType: donorName === '' ? 'byID' : 'byName',
		});

		if (donors.length <= 0) Message.info('No results found');
	};

	onFocusDonorId = () => {
		const { setFieldsValue } = this.formRef.current;

		setFieldsValue({ donorName: '' });
	};

	onFocusDonorName = () => {
		const { setFieldsValue } = this.formRef.current;

		setFieldsValue({ donorId: '' });
	};

	onClickRegister = () => {
		sessionStorage.setItem('DNR_PERSONAL_INFO', JSON.stringify({ label: 'SUBMIT' }));
		this.props.history.push('/bloodbank/donor_registration/step/2');
		// this.props.history.push('/bloodbank/donor_registration/step/2', { label: 'SUBMIT' });
	};

	onRowDoubleClick = record => {
		sessionStorage.setItem('DNR_PERSONAL_INFO', JSON.stringify({ ...record, label: 'UPDATE' }));
		this.props.history.push('/bloodbank/donor_registration/step/2');
		// this.props.history.push('/bloodbank/donor_registration/step/2', { ...record, label: 'UPDATE' });
	};

	clearInputs = () => {
		const { setFieldsValue } = this.formRef.current;

		setFieldsValue({ donorId: '', donorName: '' });

		this.setState({ actionType: '', data: [], showPagination: false });
	};

	onPagination = async page => {
		const { donorName, pageSize, donorID } = this.state;
		const donors = await searchDonors(donorName, donorID, pageSize, page);
		this.setState({
			pageSize,
			response: donors,
			count: donors.count,
			data: donors.results,
		});
	};

	showModal = () => {
		this.setState({
			modalVisible: true,
		});
	};

	hideModal = () => {
		this.setState({
			modalVisible: false,
			isDisplayModal: false,
			modalVisibleNoMatchFound: false,
		});
	};

	showModalNoMatchFound = () => {
		this.setState({
			modalVisibleNoMatchFound: true,
			modalVisible: false,
		});
	};

	showModalMatchfound = () => {
		this.setState({
			isDisplayModal: true,
			modalVisible: false,
		});
	};
	showScanAgain = () => {
		this.setState({
			modalVisible: true,
			isDisplayModal: false,
			modalVisibleNoMatchFound: false,
		});
	};

	showModalNoScannerFound = () => {
		this.setState({
			modalVisible: false,
			modalVisibleNoMatchFound: false,
			isDisplayModal: false,
			modalNoTerminalFound: true,
		});
	};

	hideModalNoScannerFound = () => {
		this.setState({
			modalVisible: false,
			modalVisibleNoMatchFound: false,
			isDisplayModal: false,
			modalNoTerminalFound: false,
		});
	};

	handleScanFinger = () => {
		//code for scanning here
		let isFound,
			hasTerminal = false;
		if (hasTerminal) {
			if (isFound) {
				this.showModalMatchfound();
			} else {
				this.showModalNoMatchFound();
			}
		} else {
			this.showModalNoScannerFound();
		}
	};

	render() {
		const {
			data,
			loading,
			count,
			pageSize,
			actionType,
			modalVisible,
			showPagination,
			isDisplayModal,
			modalVisibleNoMatchFound,
			modalNoTerminalFound,
			prodMode,
		} = this.state;

		const TableFooter = (
			<Row justify="center">
				<Button onClick={this.onClickRegister} type="link" htmlType="submit" style={{ width: 120 }}>
					REGISTER
				</Button>
			</Row>
		);

		return (
			<div>
				<PageTitle pageTitle="DONOR REGISTRATION" />
				<DonorRegSteps activeIndex={1} />
				<div className="space-y-md"></div>
				<Form
					className="blood-donor-reg-search-form"
					onFinish={this.handleSubmit}
					ref={this.formRef}
					layout="vertical"
				>
					<div className="container">
						<Col className="donor-id">
							<Form.Item label="DONOR'S ID" name="donorId">
								<RegexInput
									regex={/[0-9]/}
									maxLength={100}
									placeholder="Donor's ID"
									onFocus={this.onFocusDonorId}
								/>
							</Form.Item>
						</Col>
						<p className="font-md leading-none text">OR</p>
						<Col className="donor-name">
							<Form.Item label="DONOR'S NAME" name="donorName">
								<RegexInput
									regex={/[A-Za-z0-9, -]/}
									maxLength={100}
									placeholder="Lastname, Firstname"
									onFocus={this.onFocusDonorName}
								/>
							</Form.Item>
						</Col>
						<Col>
							<div style={{ marginTop: 25 }}>
								<Form.Item shouldUpdate>
									{({ getFieldsValue }) => {
										const { donorId, donorName } = getFieldsValue();
										const disabled = !(donorId || (donorName && donorName.length > 0));

										return (
											<div className="buttons">
												<Button
													className="form-button"
													shape="round"
													style={{ width: 120 }}
													onClick={this.clearInputs}
												>
													CLEAR
												</Button>
												<Button
													loading={loading}
													className="form-button"
													shape="round"
													type="primary"
													htmlType="submit"
													style={{ width: 120 }}
													disabled={disabled}
												>
													SEARCH
												</Button>
											</div>
										);
									}}
								</Form.Item>
							</div>
						</Col>
					</div>
				</Form>

				<Col span={24}>
					<Button
						className="form-button"
						shape="round"
						onClick={this.showModal}
						style={{
							right: '185px',
							position: 'absolute',
							zIndex: 99,
							marginTop: 15,
						}}
					>
						SCAN FINGER
					</Button>
					<SearchPager
						handleChangeSize={this.handleChangeSize}
						pageTotal={count}
						pageSize={pageSize}
					/>
				</Col>
				<div className="space-y-sm"></div>

				<div className="blood-donor-reg-search-table">
					<Table
						style={{ textTransform: 'uppercase' }}
						dataSource={data}
						columns={columns}
						pagination={false}
						rowKey={record => record.donor_id}
						onRow={record => {
							return {
								onDoubleClick: () => {
									this.onRowDoubleClick(record);
								},
							};
						}}
						{...(actionType === 'byName' && { footer: () => TableFooter })}
						// scroll={{ x: true, y: true }}
						scroll={{ x: 1500 }}
					/>
				</div>
				{showPagination === true && (
					<div style={{ display: 'flex', marginTop: 25 }}>
						<Pagination
							style={{ marginLeft: 'auto' }}
							pageSize={pageSize}
							total={count}
							onChange={this.onPagination}
						/>
					</div>
				)}

				<Modal
					title="Scan Finger"
					visible={modalVisible}
					onOk={this.handleScanFinger}
					onCancel={this.hideModal}
					okText="Scan"
					cancelText="Cancel"
					className="modal"
					footer={
						prodMode === false
							? [
									<Button key="match-found" type="primary" onClick={this.showModalMatchfound}>
										Match found
									</Button>,
									<Button key="no-match-found" type="primary" onClick={this.showModalNoMatchFound}>
										No Match found
									</Button>,
									<Button key="cancel" onClick={this.hideModal}>
										Cancel
									</Button>,
									<Button key="submit" type="primary" onClick={this.handleScanFinger}>
										Ok
									</Button>,
							  ]
							: [
									<Button key="cancel" onClick={this.hideModal}>
										Cancel
									</Button>,
									<Button key="submit" type="primary" onClick={this.handleScanFinger}>
										Ok
									</Button>,
							  ]
					}
				>
					<img style={{ height: 300, filter: 'invert' }} src={scanImage} alt="Logo" />
				</Modal>
				<NoScannerFound
					isDisplay={modalNoTerminalFound}
					hideScannerModal={this.hideModalNoScannerFound}
				/>
				<MatchFoundModal isDisplay={isDisplayModal} hideModal={this.hideModal} />
				<NoMatchFoundModal
					isDisplay={modalVisibleNoMatchFound}
					isRedirected={this.onClickRegister}
					showScan={this.showScanAgain}
				/>
			</div>
		);
	}
}

export default DonorRegSearch;
